module.exports = __webpack_public_path__ + "46f019139155f4f538a11aad05af486a.jpg";